import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, status } = useAuth();

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm font-mono uppercase tracking-wider">
        Chargement…
      </div>
    );
  }

  if (status === "unauthorized") {
    return (
      <div
        data-testid="unauthorized-screen"
        className="min-h-screen flex items-center justify-center bg-background text-center px-6"
      >
        <div>
          <p className="font-heading font-bold uppercase text-xl mb-2 text-primary">Accès non autorisé</p>
          <p className="text-sm text-muted-foreground max-w-sm">
            Votre compte Google n'est pas encore activé sur HFACS. Contactez un administrateur.
          </p>
        </div>
      </div>
    );
  }

  if (status !== "authenticated") {
    return <Navigate to="/" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
